// this file is generated by update_shopify_store_data.py at 2026-02-23 20:27:32.717898
var courses = [
    {
        "course_id": "61A3F097-79C5-F011-99A1-005056A730AF",
        "course_version": 4,
        "name": "Springer Publishing - C-EFM\u00ae Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Electronic Fetal Monitoring (C-EFM\u00ae) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nC-EFM\u00ae is a registered trademark of the National Certification Corporation (NCC). The NCC does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and physiologic principles related to electronic fetal monitoring and perinatal care.</li>\r\n    <li>Apply critical-thinking and interpretation skills to analyze fetal heart rate patterns and maternal-fetal clinical scenarios.</li>\r\n    <li>Demonstrate readiness for the C-EFM&reg; certification exam through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<ul>\r\n    <li>Introduction</li>\r\n    <li>Module 1: Certification Exam</li>\r\n    <li>Module 2: Fetal Assessment Methods</li>\r\n    <li>Module 3: Maternal, Fetal, and Placental Physiology</li>\r\n    <li>Module 4: Assessment of Fetal Oxygenation and Acid&amp;ndashBase Status</li>\r\n    <li>Module 5: Maternal, Fetal, and Placental Complications</li>\r\n    <li>Module 6: Interpretation of Fetal Heart Rate and Uterine Patterns</li>\r\n    <li>Module 7: Interventions for Fetal Heart Rate and Uterine Pattern Abnormalities</li>\r\n    <li>Module 8: Clinical Communication and Professional Issues</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "0E5C0830-D7C9-E511-82AF-005056B150D3",
                "course_category_name": "Patient Experience",
                "is_system_course_category": null
            },
            {
                "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                "course_category_name": "Obstetric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                "course_category_name": "Patient Monitoring",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "26EF2AA5-22FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Obstetric Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];